<div *ngIf="voucher" class="row m-0 align-items-center">
  <div class="col-6 voucher-title m-0 ps-0">
    <span>{{voucher.name}}</span>
  </div>
  <div class="col-6 text-end pe-0">
    <i class="fa fa-plus rotate-45 pointer" (click)="onClickRemoveVoucher($event)"></i>
    <!-- <button class="btn btn-link px-0"
            (click)="onClickRemoveVoucher($event)">{{ 'voucher.remove-voucher' | translate }}</button> -->
  </div>
</div>